<template>
  <v-card
    ref="listRoot"
    class="ma-0 px-1 app-list-page"
    :class="{
      'app-list-page--fixed': !isMobile && !mobileShow,
    }"
    width="100%"
    style="height: auto"
    flat
  >
    <v-app-bar
      ref="listToolbar"
      flat
      class="my-0 app-list-toolbar"
      :class="!isMobile && !mobileShow ? 'px-2 mb-0 py-0' : 'mb-6 py-1 px-2'"
      dense
      :height="!isMobile && !mobileShow ? 40 : 30"
    >
      <v-toolbar-title
        class="app-list-toolbar__title"
        :class="!isMobile && !mobileShow ? 'me-4' : 'mt-4 me-4'"
        >{{ $t($route.name) }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
    </v-app-bar>
    <v-col ref="listTableCol" cols="12" class="px-2 app-list-table-col">
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="reportColumnPlugins"
        v-column-drag="reportColumnPlugins"
        v-column-pin="reportColumnPlugins"
        :height="isMobile || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        multi-sort
        dense
        :show-select="false"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        class="mb-2 td-hide-border app-list-table main-table invoice-sell-table-scroll"
        :class="{
          'mb-0 app-list-table--dense': !isMobile && !mobileShow,
        }"
        :style="
          !isMobile && !mobileShow
            ? 'border: 1px solid #e3e3e3; border-radius: 2px'
            : 'border: 1px solid #e3e3e3; border-radius: 6px'
        "
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-if="isMobile" v-slot:item="{ item, index }">
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-red': item.type == 'cost' ? true : false,
                  'mobile-td-list-border-green': item.type == 'income' ? true : false,
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item link @click="print('invoiceIncomePrint', item)">
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('print')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="
                            'https://abr.abriron.com/pi/' +
                            item.uid +
                            '?' +
                            'cuid=' +
                            cuid
                          "
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{
                      item.account && item.account.name
                        ? item.account.name
                        : $t("haveNot")
                    }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("bank") }} :
                    {{ item.bank && item.bank.name ? item.bank.name : $t("haveNot") }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("date") }} : {{ item.date ? item.date : $t("haveNot") }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("count") }} :
                    {{ item.count != null && item.count !== "" ? item.count : $t("haveNot") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <span v-if="item.sum != null && item.sum !== ''" class="primary--text">
                    {{
                      $numberFormat(
                        parseFloat(item.sum),
                        item.currency ? item.currency.decimal : 0
                      )
                    }}
                    {{ item.currency ? item.currency.name : "" }}
                  </span>
                  <span v-else>{{ $t("haveNot") }}</span>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item link @click="print('invoiceIncomePrint', item)">
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="
                  'https://abr.abriron.com/pi/' + item.uid + '?' + 'cuid=' + cuid
                "
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.date="{ item }">
          {{ item.date ? item.date : $t("haveNot") }}
        </template>
        <template v-slot:item.bank.name="{ item }">
          {{ item.bank && item.bank.name ? item.bank.name : $t("haveNot") }}
        </template>
        <template v-slot:item.account.name="{ item }">
          {{ item.account && item.account.name ? item.account.name : $t("haveNot") }}
        </template>
        <template v-slot:item.count="{ item }">
          {{ item.count != null && item.count !== "" ? item.count : $t("haveNot") }}
        </template>
        <template v-slot:item.sum="{ item }">
          <span v-if="item.sum != null && item.sum !== ''" class="primary--text">
            {{
              $numberFormat(
                parseFloat(item.sum),
                item.currency ? item.currency.decimal : 0
              )
            }}
            {{ item.currency ? item.currency.name : "" }}
          </span>
          <span v-else>{{ $t("haveNot") }}</span>
        </template>
        <template v-slot:body.append>
          <tr
            v-if="isMobile || mobileShow"
            :class="{ 'v-data-table__mobile-table-row': isMobile }"
          >
            <td
              :colspan="`${isMobile ? 6 : 4}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("count") + ":" : "" }}
              {{ $numberFormat(totals.count) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("amount") + ":" : "" }}
              {{ $numberFormat(totals.sum) }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t("sumInPage") }}</span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("count") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.count) }}
              </span>
            </span>
            <span
              class="app-list-page-totals__item app-list-page-totals__item--final"
            >
              <span class="app-list-page-totals__key">{{ $t("amount") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sum) }}
                {{ $store.state.currency.name }}
              </span>
            </span>
          </div>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0 app-list-goto-page"
            :class="{
              'app-list-goto-page--compact': !isMobile && !mobileShow,
            }"
            :style="
              !isMobile && !mobileShow ? null : 'margin-top: -10px'
            "
          >
            <!-- Flat glass: no border/shadow — bg via inline so footer CSS cannot override -->
            <div
              class="app-list-goto-page__box"
              :style="
                !isMobile && !mobileShow
                  ? {
                      height: '24px',
                      padding: '0 8px',
                      borderRadius: '4px',
                      backgroundColor: 'rgba(120, 130, 140, 0.12)',
                      border: 'none',
                      boxShadow: 'none',
                      backdropFilter: 'blur(10px)',
                      WebkitBackdropFilter: 'blur(10px)',
                    }
                  : null
              "
            >
              <span
                v-if="!isMobile && !mobileShow"
                class="app-list-goto-page__label"
                >{{ $t("goToPage") }}</span
              >
              <v-text-field
                v-model.number="page"
                :label="
                  !isMobile && !mobileShow ? undefined : $t('goToPage')
                "
                min="1"
                :max="pageCount"
                type="number"
                :outlined="isMobile || isTablet || mobileShow"
                :solo="!isMobile && !mobileShow"
                :flat="!isMobile && !mobileShow"
                :height="!isMobile && !mobileShow ? 20 : 32"
                hide-details
                hide-spin-buttons
                dense
                :suffix="' / ' + pageCount"
                class="app-list-goto-page__field"
              />
            </div>
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <autocomplete
              v-model="detail"
              :title="$t('costIncome')"
              type="alldetail"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="account"
              title="account"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="bank"
              :title="$t('bank') + '/' + $t('cash')"
              type="bankCash"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <money
              v-model="fromAmount"
              :dense="true"
              :label="$t('from') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col cols="12" md="4">
            <money
              v-model="toAmount"
              :dense="true"
              :label="$t('until') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar v-model="snakbar" :text="snakbarText" :active="snakbar" />
  </v-card>
</template>

<script>
import General from "../../../../Mixins/general";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
export default {
  name: "CostIncomeReport",
  components: {
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
  },
  mixins: [General],
  props: ["input", "type", "refId", "mobileShow"],
  data: () => ({
    printHeaders: [],
    excelItems: [],
    pageCount: 1,
    page: 1,
    detail: null,
    bank: null,
    account: null,
    fromAmount: null,
    toAmount: null,
    printDialog: false,
    filter: false,
    fromDate: null,
    toDate: null,
    tag: null,
    items: [],
    sortBy: [],
    totalItems: 0,
    snakbar: false,
    subType: null,
    snakbarText: null,
    listViewportObserver: null,
    listViewportRaf: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    cuid: null,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    reportColumnPersistKey() {
      return "cost-income-report-columns-" + (this.$route.name || "costIncomeReport");
    },
    reportLockedColumns() {
      // Fixed sticky block: actions only — report has no select/row/id columns
      return ["actions"];
    },
    reportColumnPlugins() {
      return {
        headers: this.headers,
        visibleHeaders: this.headers || [],
        locked: this.reportLockedColumns,
        anchor: "date",
        minWidth: 60,
        persistKey: this.reportColumnPersistKey,
      };
    },
    totals: function () {
      return this.items.reduce(
        (acc, d) => {
          acc.count += d.count != null && d.count !== "" ? parseFloat(d.count) : 0;
          acc.sum += d.sum != null && d.sum !== "" ? parseFloat(d.sum) : 0;
          return acc;
        },
        {
          count: 0,
          sum: 0,
        }
      );
    },
  },
  watch: {
    refId() {
      this.getItems();
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          if (index > -1 && app.headers[index].table) {
            app.sortBy.push(app.headers[index].table);
          }
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
  },
  beforeMount() {
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "cost_income.date",
      },
      {
        text: this.$t("bank"),
        sortable: false,
        value: "bank.name",
      },
      {
        text: this.$t("income"),
        sortable: true,
        value: "account.name",
        table: "financial_detail_coding.name",
      },
      {
        text: this.$t("count"),
        sortable: false,
        value: "count",
      },
      {
        text: this.$t("amount"),
        sortable: true,
        value: "sum",
        table: "cost_income.sum",
      },
    ];
    reorderPinnedHeaders(this.headers, {
      locked: this.reportLockedColumns,
      anchor: "date",
    });
    this.loadReportColumnSettings();
    this.printHeaders = [
      {
        text: this.$t("date"),
        value: "date",
      },
      {
        text: this.$t("bank"),
        value: "bank.name",
      },
      {
        text: this.$t("income"),
        value: "account.name",
      },
      {
        text: this.$t("count"),
        value: "count",
      },
      {
        text: this.$t("amount"),
        value: "sum",
        sum: true,
        type: "number",
      },
    ];
  },
  mounted() {
    this.cuid = localStorage.getItem("cuid");
    this.getItems();
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  activated() {
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
  methods: {
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null ||
          summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl
        ? tableEl.querySelector(".v-data-footer")
        : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadReportColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.reportColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.reportLockedColumns,
          anchor: "date",
        });
        app.$forceUpdate();
      });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "CostIncome/report", {
          params: {
            page: app.allRows ? app.excelPage : app.options.page,
            refId: app.refId,
            branch: app.branch,
            type: app.type,
            subType: app.subType,
            fromDate: app.fromDate,
            toDate: app.toDate,
            sortBy: app.sortBy,
            options: app.options,
            tag: app.tag,
            detail: app.detail,
            account: app.account,
            bank: app.bank,
            fromAmount: app.fromAmount,
            toAmount: app.toAmount,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            const rows = Array.isArray(res.data) ? res.data : [];
            const checkData = rows.map((row) => {
              const bankName =
                row.bank && typeof row.bank === "object"
                  ? row.bank.name
                  : row.bank || "";
              const incomeName =
                row.account && typeof row.account === "object"
                  ? row.account.name
                  : row.income || row.account || "";
              return {
                ...row,
                account: { name: incomeName },
                bank: { name: bankName },
                currency: row.currency || { name: "", decimal: 0 },
                count: row.count != null ? row.count : row.transaction_count,
                sum: row.sum,
              };
            });
            app.items = checkData;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.creatExcelData(app.items);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    print(to, item) {
      var routeData = this.$router.resolve({ name: to, params: { id: item.uid } });
      window.open(routeData.href, "_blank");
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          date: d.date ? d.date : app.$t("haveNot"),
          bank: d.bank && d.bank.name ? d.bank.name : app.$t("haveNot"),
          income: d.account && d.account.name ? d.account.name : app.$t("haveNot"),
          count: d.count != null && d.count !== "" ? d.count : app.$t("haveNot"),
          amount: d.sum != null && d.sum !== "" ? d.sum : app.$t("haveNot"),
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
</style>
